import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
import useTheme from '../styles/use-theme';
var defaultProps = {
  className: ''
};

var ModalContent = function ModalContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useTheme();
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement("div", _extends({}, props, {
      className: _JSXStyle.dynamic([["2191767584", [theme.layout.gap, theme.layout.gap, theme.layout.gap, theme.layout.gapHalf]]]) + " " + (props && props.className != null && props.className || "content ".concat(className))
    }), children),
    /*#__PURE__*/
    React.createElement(_JSXStyle, {
      id: "2191767584",
      dynamic: [theme.layout.gap, theme.layout.gap, theme.layout.gap, theme.layout.gapHalf]
    }, ".content.__jsx-style-dynamic-selector{margin:0 -".concat(theme.layout.gap, ";padding:").concat(theme.layout.gap, " ").concat(theme.layout.gap, " ").concat(theme.layout.gapHalf, ";position:relative;text-align:left;}.content.__jsx-style-dynamic-selector>*:first-child{margin-top:0;}.content.__jsx-style-dynamic-selector>*:last-child{margin-bottom:0;}")))
  );
};

var MemoModalContent =
/*#__PURE__*/
React.memo(ModalContent);
export default withDefaults(MemoModalContent, defaultProps);